import { useState, useEffect } from 'react';
import {
    Box, Paper, TextField, Typography, Tabs, Tab, Autocomplete,
    FormControlLabel, Radio, Button, Checkbox, CircularProgress
} from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../Styles/Colors';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import LoopIcon from '@mui/icons-material/Loop';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';

const formatList = [
    { label: "A4 Portrait", value: "portrait_a4" },
    // { label: "A4 Landscape", value: "landscape_a4" },
    { label: "A5 Portrait", value: "portrait_a5" },
    // { label: "A5 Landscape", value: "landscape_a5" }
]

const fontList = [
    { label: "Arial", value: "Arial" },
    { label: "Times New Roman", value: "TimesNewRoman" },
    { label: "Calibri", value: "Calibri" },
    { label: "Verdana", value: "Verdana" },
    { label: "Helvetica", value: "Helvetica" }
]

const fontSizeList = [8, 9, 10, 11, 12];

const maxCount4 = new Set(["Margintop", "MarginRight", "MarginBottom", "MarginLeft"])

const RadResultPrint = () => {
    const [state, setState] = useState({
        previewUrl: "",
        previewLoader: false,
        tabValue: 'basic',
        basicData: {
            format: "portrait_a4",
            font: "Helvetica",
            fontSize: 8,
            Margintop: "0.5",
            MarginRight: "0.5",
            MarginBottom: "0.5",
            MarginLeft: "0.5",
            withOutHeader: "",
            woHeadSpace: "",
            withOutFooter: "",
            woFootSpace: "",
            withHeader: "withHeader",
            printHeaderAllpages: true,
            withFooter: "withFooter",
            printFooterAllpages: true,
            tabSpacingContent: true,
            lineSpacing: "1.5",
        },
        validationBasicError: {
            Margintop: "",
            MarginRight: "",
            MarginBottom: "",
            MarginLeft: "",
            woHeadSpace: "",
            woFootSpace: "",
        },
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
        isLoader: false,
    })

    useEffect(() => {
        getLayoutData()
        getPreviewUrl()
    }, [])

    const updateState = (newState) => {
        setState((prevState) => ({
            ...prevState,
            ...newState
        }))
    }

    const findValue = (list = [], value) => {
        return list?.find(item => item.value === value) || null;
    }

    const toValidStr = (val, fallback = "0.5") => {
        return val != null ? String(val) : fallback;
    };

    const getLayoutData = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const is_investigation = localGetItem('is_investigation_module') === "true";
        const url = (localGetItem("isNewBilling") === "true" && is_investigation) ?
            Serviceurls.INVESTIGATION_RESULT_PRINT_CONFIGURATION
            : Serviceurls.RAD_RESULT_PRINT_CONFIGURATION;
        const id = is_investigation ? "investigation_id" : "radiology_id";
        try {
            RestAPIService.getAll(url + `?${id}=${loginInfo[id] || ''}&clinic_id=${loginInfo?.clinic_id || ''}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data;
                        updateState({
                            basicData: {
                                format: Data?.format || "portrait_a4",
                                font: Data?.font || "Helvetica",
                                fontSize: Data?.font_size || 8,
                                Margintop: toValidStr(Data?.margin_top),
                                MarginRight: toValidStr(Data?.margin_right),
                                MarginBottom: toValidStr(Data?.margin_bottom),
                                MarginLeft: toValidStr(Data?.margin_left),
                                withOutHeader: Data?.with_out_header || "",
                                woHeadSpace: toValidStr(Data?.header_space, ""),
                                withOutFooter: Data?.with_out_footer || "",
                                woFootSpace: toValidStr(Data?.footer_space, ""),
                                withHeader: Data?.with_header,
                                printHeaderAllpages: Data?.print_header_allpages,
                                withFooter: Data?.with_footer,
                                printFooterAllpages: Data?.print_footer_allpages,
                                tabSpacingContent: Data?.tab_spacing_content,
                                lineSpacing: toValidStr(Data?.line_spacing, "1.5"),
                            },
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPreviewUrl = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const url = (localGetItem("isNewBilling") === "true" ? (localGetItem('is_investigation_module') === "true" ?
            Serviceurls.NEW_INVESTIGATION_RESULT_PRINT : Serviceurls.NEW_RAD_RESULT_PRINT) : Serviceurls.RAD_RESULT_PRINT);
        try {
            updateState({ previewUrl: "", previewLoader: true })
            RestAPIService.getAll(`${url}?clinic_id=${loginInfo?.clinic_id || ''}&check_payment_status=true&preview=true`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    updateState({
                        previewUrl: fileURL,
                        previewLoader: false
                    })
                }).catch((e) => {
                    updateState({ previewLoader: false })
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            updateState({ previewLoader: false })
            errorMessage(e?.response?.data?.message || e.message)
        }
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }
    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const resetPrintDetails = () => {
        updateState({
            basicData: {
                format: "portrait_a4",
                font: "Helvetica",
                fontSize: 8,
                Margintop: "0.5",
                MarginRight: "0.5",
                MarginBottom: "0.5",
                MarginLeft: "0.5",
                withOutHeader: "",
                woHeadSpace: "",
                withOutFooter: "",
                woFootSpace: "",
                withHeader: "withHeader",
                printHeaderAllpages: true,
                withFooter: "withFooter",
                printFooterAllpages: true,
                tabSpacingContent: true,
                lineSpacing: "1.5",
            },
            validationBasicError: {
                Margintop: "",
                MarginRight: "",
                MarginBottom: "",
                MarginLeft: "",
            },
            isLoader: false,
        })
    }

    const validateItem = () => {
        const { basicData } = state;

        const format = basicData.format || "";
        const isPortraitA4 = format === "portrait_a4";
        const isPortraitA5 = format === "portrait_a5";
        const isLandscape = format?.includes("landscape");

        const left = parseFloat(basicData.MarginLeft) || 0;
        const right = parseFloat(basicData.MarginRight) || 0;
        const top = parseFloat(basicData.Margintop) || 0;
        const bottom = parseFloat(basicData.MarginBottom) || 0;

        const errors = {};
        let firstError = "";

        let leftRightSumValid = true;
        let topBottomSumValid = true;

        // Step 1: Check sum limits
        if (isPortraitA4 && (left + right) > 4) {
            const msg = "Sum of Left and Right margins should not exceed 4cm.";
            errors.MarginLeft = msg;
            errors.MarginRight = msg;
            leftRightSumValid = false;
            if (!firstError) firstError = msg;
        }

        if (isPortraitA5) {
            if ((left + right) > 2) {
                const msg = "Sum of Left and Right margins should not exceed 2cm.";
                errors.MarginLeft = msg;
                errors.MarginRight = msg;
                leftRightSumValid = false;
                if (!firstError) firstError = msg;
            }
            if ((top + bottom) > 2) {
                const msg = "Sum of Top and Bottom margins should not exceed 2cm.";
                errors.Margintop = msg;
                errors.MarginBottom = msg;
                topBottomSumValid = false;
                if (!firstError) firstError = msg;
            }
        }

        if (isLandscape && (top + bottom) > 4) {
            const msg = "Sum of Top and Bottom margins should not exceed 4cm.";
            errors.Margintop = msg;
            errors.MarginBottom = msg;
            topBottomSumValid = false;
            if (!firstError) firstError = msg;
        }

        // Step 2: Required fields only if sum is invalid or sum is 0
        const fields = [
            { key: "Margintop", label: "Margin Top", skipIfSumValid: top + bottom > 0 && topBottomSumValid },
            { key: "MarginRight", label: "Margin Right", skipIfSumValid: left + right > 0 && leftRightSumValid },
            { key: "MarginBottom", label: "Margin Bottom", skipIfSumValid: top + bottom > 0 && topBottomSumValid },
            { key: "MarginLeft", label: "Margin Left", skipIfSumValid: left + right > 0 && leftRightSumValid },
            { key: "woHeadSpace", label: "Header Spacing", condition: basicData.withOutHeader },
            { key: "woFootSpace", label: "Footer Spacing", condition: basicData.withOutFooter },
        ];

        for (const { key, label, condition = true, skipIfSumValid = false } of fields) {
            const value = basicData?.[key];

            if (condition && value === "" && !skipIfSumValid) {
                const message = `${label} is required.`;
                errors[key] = message;
                if (!firstError) firstError = message;
            } else {
                if (!errors[key]) errors[key] = "";
            }
        }

        // Step 3: Update validation state
        updateState({
            validationBasicError: {
                ...state.validationBasicError,
                ...errors,
            },
        });

        // Step 4: Return true if no errors
        return Object.values(errors).every(msg => !msg);
    };

    const validationData = () => {
        updateState({ isLoader: true });
        const validMsg = validateItem() ? "" : "Please fill all the required fields in Basic Layout";

        const errorMsg = validMsg;
        if (errorMsg === "") {
            postPrintDetails();
        } else {
            updateState({
                isLoader: false,
                isErrorMsg: true,
                isErrorMsgText: errorMsg
            });
        }
    }

    const toValidNumber = (val, fallback = 0.5) => {
        const num = parseFloat(val);
        return isNaN(num) ? fallback : num;
    };

    const postPrintDetails = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'));
        const is_investigation = localGetItem('is_investigation_module') === "true"
        const url = (localGetItem("isNewBilling") === "true" && is_investigation) ?
            Serviceurls.INVESTIGATION_RESULT_PRINT_CONFIGURATION
            : Serviceurls.RAD_RESULT_PRINT_CONFIGURATION
        const id = is_investigation ? "investigation_id" : "radiology_id"

        try {
            const data = {
                [id]: loginInfo[id] || null,
                clinic_id: loginInfo?.clinic_id || null,
                basic_layout: {
                    format: state.basicData.format || "portrait_a4",
                    font: state.basicData.font || "Helvetica",
                    font_size: state.basicData.fontSize || 8,
                    margin_top: toValidNumber(state.basicData.Margintop),
                    margin_right: toValidNumber(state.basicData.MarginRight),
                    margin_bottom: toValidNumber(state.basicData.MarginBottom),
                    margin_left: toValidNumber(state.basicData.MarginLeft),
                    with_out_header: state.basicData.withOutHeader || "",
                    header_space: toValidNumber(state.basicData.woHeadSpace, 0),
                    with_out_footer: state.basicData.withOutFooter || "",
                    footer_space: toValidNumber(state.basicData.woFootSpace, 0),
                    with_header: state.basicData.withHeader || "",
                    print_header_allpages: state.basicData.printHeaderAllpages,
                    with_footer: state.basicData.withFooter || "",
                    print_footer_allpages: state.basicData.printFooterAllpages,
                    tab_spacing_content: state?.basicData?.tabSpacingContent,
                    line_spacing: toValidNumber(state?.basicData?.lineSpacing, 1.5),
                },
            }

            RestAPIService.create(data, url)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        updateState({ isLoader: false });
                        getLayoutData();
                        getPreviewUrl();
                    }
                }).catch((error) => {
                    errorMessage(error.response.data.message || error.message)
                    updateState({ isLoader: false });
                })
        }
        catch (e) {
            errorMessage(e.message)
            updateState({ isLoader: false });
        }
    }

    const handleBasicDataChange = (key, value) => {
        const num = parseFloat(value);
        switch (key) {
            case "format":
                const obj = {
                    Margintop: "",
                    MarginRight: "",
                    MarginBottom: "",
                    MarginLeft: "",
                }
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        ...obj,
                    },
                    validationBasicError: {
                        ...state.validationBasicError,
                        ...obj,
                    }
                });
                break;
            case "Margintop":
            case "MarginRight":
            case "MarginBottom":
            case "MarginLeft":
                const valNum = CommonValidation.DecimalNumberOne(value);
                if (value === "") {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value
                        },
                        validationBasicError: {
                            ...state.validationBasicError,
                            [key]: ""
                        }
                    });
                    break;
                } else if (valNum && num >= 0 && num <= 4) {
                    let updatedBasicData = { ...state.basicData, [key]: value };
                    const isLandscape = updatedBasicData.format?.includes("landscape");

                    // Clear all margin errors initially
                    let validationErrors = {
                        ...state.validationBasicError,
                        MarginLeft: "",
                        MarginRight: "",
                        Margintop: "",
                        MarginBottom: ""
                    };

                    const left = parseFloat(updatedBasicData.MarginLeft) || 0;
                    const right = parseFloat(updatedBasicData.MarginRight) || 0;
                    const top = parseFloat(updatedBasicData.Margintop) || 0;
                    const bottom = parseFloat(updatedBasicData.MarginBottom) || 0;

                    // Margin sum validation
                    if (updatedBasicData.format === "portrait_a4" && (key === "MarginRight" || key === "MarginLeft")) {
                        if ((left + right) > 4) {
                            const msg = "Sum of Left and Right margins should not exceed 4cm";
                            if (left) validationErrors.MarginLeft = msg;
                            if (right) validationErrors.MarginRight = msg;
                        }
                    }
                    if (updatedBasicData.format === "portrait_a5" && (key === "MarginRight" || key === "MarginLeft" || key === "Margintop" || key === "MarginBottom")) {
                        if ((left + right) > 2) {
                            const msg = "Sum of Left and Right margins should not exceed 2cm";
                            if (left) validationErrors.MarginLeft = msg;
                            if (right) validationErrors.MarginRight = msg;
                        }
                        if ((top + bottom) > 2) {
                            const msg = "Sum of Top and Bottom margins should not exceed 2cm";
                            if (top) validationErrors.Margintop = msg;
                            if (bottom) validationErrors.MarginBottom = msg;
                        }
                    }
                    if (isLandscape && (key === "Margintop" || key === "MarginBottom")) {
                        if ((top + bottom) > 4) {
                            const msg = "Sum of Top and Bottom margins should not exceed 4cm";
                            if (top) validationErrors.Margintop = msg;
                            if (bottom) validationErrors.MarginBottom = msg;
                        }
                    }

                    // Only set minimum value error if there's no sum error
                    if (!validationErrors[key] && num < 0.5 && num !== 0) {
                        validationErrors[key] = "Value should be greater than or equal to 0.5";
                    }
                    updateState({
                        basicData: updatedBasicData,
                        validationBasicError: validationErrors
                    });
                }
                break;
            case "withOutHeader":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        withHeader: "",
                        printHeaderAllpages: false,
                    }
                });
                break;
            case "withHeader":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        printHeaderAllpages: true,
                        withOutHeader: "",
                        woHeadSpace: "",
                    }
                });
                break;
            case "withOutFooter":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        withFooter: "",
                        printFooterAllpages: false,
                    }
                });
                break;
            case "withFooter":
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                        printFooterAllpages: true,
                        withOutFooter: "",
                        woFootSpace: "",
                    }
                });
                break;
            case "woHeadSpace":
                const val = CommonValidation.DecimalNumberOne(value)
                if (value === '' || (val && num >= 0 && num <= 2)) {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value,
                        }
                    })
                }
                break;
            case "woFootSpace":
                const numVal = CommonValidation.DecimalNumberOne(value)
                if (value === '' || (numVal && num >= 0 && num <= 2)) {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value,
                        }
                    })
                }
                break;
            case "lineSpacing":
                const num_val = CommonValidation.DecimalNumberOne(value)
                if (value === '' || (num_val && num >= 1 && num <= 2)) {
                    updateState({
                        basicData: {
                            ...state.basicData,
                            [key]: value,
                        }
                    })
                }
                break;
            default:
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value,
                    }
                });
                break;
        }
    };

    const renderAutoComplete = (label, statekey, value, list = [], showKey, handleChange, isDisable = false, width) => {
        return (
            <Box>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{label}</Typography>}
                <Autocomplete
                    size="small"
                    options={list || []}
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.[showKey] ? option[showKey] || "" : JSON.stringify(option))}
                    value={statekey === "fontSize" ? value : findValue(list, value) || null}
                    disabled={isDisable}
                    disableClearable
                    onChange={(event, newValue) => { handleChange(statekey, newValue) }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ width: width ? width : "100%" }}
                            size='small'
                            autoComplete="off"
                            inputProps={{
                                ...params.inputProps,
                            }}
                        />
                    )}
                />
            </Box>
        );
    };

    const renderTextField = (label = "", name, value, showHelper = false, handleChange) => {
        return (
            <Box sx={{ width: handleChange ? "100%" : "40%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} flex={0.4}>{label}</Typography>}
                <TextField
                    size='small'
                    sx={{ flex: (handleChange || label === "") ? 1 : 0.6 }}
                    autoComplete='off'
                    disabled={
                        (name === "woHeadSpace" && !state.basicData?.withOutHeader) ||
                            (name === "woFootSpace" && !state.basicData?.withOutFooter)
                            ? true
                            : false
                    }
                    value={value}
                    inputProps={{ maxLength: maxCount4.has(name) ? 4 : 25 }}
                    onChange={(e) => { (handleChange || handleBasicDataChange)(name, e.target.value) }}
                    InputProps={{
                        endAdornment: <Typography>{handleChange ? "" : showHelper ? "px" : "cm"}</Typography>,
                        emed_tid: `Field_${name}`
                    }}
                    helperText={state.validationBasicError[name] || ""}
                    error={Boolean(state.validationBasicError[name])}
                />
            </Box>
        )
    }

    const renderLineSpacingTxt = () => {
        return (
            <Box>
                <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Line Spacing</Typography>
                <TextField
                    sx={{ width: "13vw" }}
                    size='small'
                    autoComplete='off'
                    value={state.basicData.lineSpacing}
                    onChange={(e) => { handleBasicDataChange("lineSpacing", e.target.value) }}
                    InputProps={{
                        endAdornment: <Typography>px</Typography>,
                        emed_tid: `Field_lineSpacing`
                    }}
                />
            </Box>)
    }

    const renderButton = (label, variant, onClick) => {
        let editAccess = CheckAccessFunc('Radiology', "Settings", 'Result Configuration', null, "Tab")?.editAccess
        return (<Button
            emed_tid={`lab_print_${label}`}
            disabled={state?.isLoader || (label === 'Save' && !editAccess)}
            variant={variant}
            size="small"
            id="eMed_Config_btn"
            sx={{ width: "10vw" }}
            onClick={() => { onClick() }}
            startIcon={label === "Save & Refresh" ? <LoopIcon /> : null}>
            {label}
        </Button>)
    }

    const renderRadioBtn = (label, value, checked, stateKey) => {
        return (
            <FormControlLabel control={
                <Radio size='small'
                    checked={checked}
                    value={value}
                    onChange={(e) => { handleBasicDataChange(stateKey, e.target.value) }}
                />}
                label={label} />
        )
    }

    const renderCheckbox = (label, stateKey, value, handleChange, isDisable = false) => {
        const changeHandler = handleChange || handleBasicDataChange;
        return (
            <FormControlLabel
                control={<Checkbox
                    disabled={isDisable}
                    checked={value}
                    onChange={(e) => { changeHandler(stateKey, e.target.checked) }}
                    size='small' />}
                label={<Typography fontSize={'0.9vw'} fontWeight={600}>
                    {label}
                </Typography>} />
        )
    }

    const renderHeadFooter = (text1, text2) => {
        return (
            <Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.4} color={"#8a8585"}>{text1}</Typography>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.6} color={"#8a8585"}>{text2}</Typography>
            </Box>
        )
    }

    const renderHeaderRow = (leftContent, rightContent) => {
        return (<Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
            <Box sx={{ flex: 0.4 }}>{leftContent}</Box>
            <Box sx={{ flex: 0.6 }}>{rightContent}</Box>
        </Box>)
    }

    const renderBasicLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw", borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    {renderAutoComplete("Format", "format", state.basicData.format, formatList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, false, "13vw")}
                    {renderAutoComplete("Font", "font", state.basicData.font, fontList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, false, "13vw")}
                    {renderAutoComplete("Font Size", "fontSize", state.basicData.fontSize, fontSizeList, "", (key, value) => { handleBasicDataChange(key, value) }, false, "13vw")}
                    {renderLineSpacingTxt()}
                </Box>
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Margin setup</Typography>
                    <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>Settings</Typography>
                    {renderTextField("Top", "Margintop", state.basicData.Margintop)}
                    {renderTextField("Bottom", "MarginBottom", state.basicData.MarginBottom)}
                    {renderTextField("Left", "MarginLeft", state.basicData.MarginLeft)}
                    {renderTextField("Right", "MarginRight", state.basicData.MarginRight)}
                </Box>
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw", borderBottom: "1px solid lightGray", }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Header and Footer</Typography>
                    {/* Header */}
                    {renderHeadFooter("Header", "Spacing Height")}
                    {renderHeaderRow(
                        renderRadioBtn("With Out Header", "withoutHeader", state.basicData.withOutHeader, "withOutHeader"),
                        renderTextField("", "woHeadSpace", state.basicData.woHeadSpace))
                    }
                    {renderHeaderRow(
                        renderRadioBtn("With Header", "withHeader", state.basicData.withHeader, "withHeader"),
                        renderCheckbox("Print Header In All Pages", "printHeaderAllpages", state.basicData.printHeaderAllpages, state.basicData.withHeader === ""))
                    }
                    {/* Footer */}
                    {renderHeadFooter("Footer", "Spacing Height")}
                    {renderHeaderRow(
                        renderRadioBtn("With Out Footer", "withoutFooter", state.basicData.withOutFooter, "withOutFooter"),
                        renderTextField("", "woFootSpace", state.basicData.woFootSpace))
                    }
                    {renderHeaderRow(
                        renderRadioBtn("With Footer", "withFooter", state.basicData.withFooter, "withFooter"),
                        renderCheckbox("Print Footer In All Pages", "printFooterAllpages", state.basicData.printFooterAllpages, state.basicData.withFooter === "")
                    )}
                </Box>
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw", borderBottom: "1px solid lightGray", }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Line Spacing</Typography>
                    {renderCheckbox("Add Tab Spacing for content", "tabSpacingContent", state.basicData.tabSpacingContent)}
                </Box>
            </Box>
        )
    }

    const renderTabContent = (tabValue) => {
        switch (tabValue) {
            case 'basic':
                return renderBasicLayout();
            default:
                return null;
        }
    }

    return (
        <Box sx={{ height: "78.5vh" }}>
            <Box className='eMed_lab_printDiv'>
                <Paper elevation={2}>
                    <Box className='eMed_refdoc_title' display={"flex"} justifyContent={"space-between"} alignItems={"center"} padding={"1vw"}>
                        <Typography className='eMed_refdoc_title' padding={"0vw"}>{"Print Preview"}</Typography>
                        {/* {renderButton("Save & Refresh", 'contained', validationData)} */}
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "72.5vh", overflowY: "auto" }}>
                        {state.previewLoader ?
                            <CircularProgress color="primary" size={"2vw"} />
                            : state.previewUrl ? <iframe
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                                src={`${state.previewUrl}#toolbar=1&navpanes=0`}
                                type="application/pdf" />
                                : <Typography fontSize={"1vw"}>No Records to be shown</Typography>}
                    </Box>
                </Paper>
                <Paper elevation={2}>
                    <Tabs
                        value={state.tabValue}
                        onChange={(e, newValue) => { updateState({ tabValue: newValue }) }}
                        sx={{ backgroundColor: Colors.DataTblHeaderbg, height: "6vh" }}
                    >
                        <Tab value={'basic'} label='Basic Layout' className='eMed_tab_header' />
                    </Tabs>
                    <Box sx={{ height: "66.5vh", overflowY: "auto", padding: "0.5vw" }}>
                        {renderTabContent(state.tabValue)}
                    </Box>
                    <Box sx={{
                        width: "100%", display: "flex", justifyContent: "flex-end",
                        alignItems: "center", height: "6vh", gap: "0.5vw",
                        backgroundColor: Colors.DataTblHeaderbg, paddingRight: "0.625vw"
                    }}>
                        {renderButton("Reset", 'outlined', resetPrintDetails)}
                        {renderButton("Save", 'contained', validationData)}
                    </Box>
                </Paper>
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}

export default withTranslation()(RadResultPrint)